const DialogType = Object.freeze({
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
});

export default DialogType;
